import React from 'react';
interface StatusSummaryCardsProps {
  counts: {
    new: number;
    requested: number;
    review: number;
    cleared: number;
  };
}
export function StatusSummaryCards({
  counts
}: StatusSummaryCardsProps) {
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-412">
      <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-sm" data-id="element-413">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1" data-id="element-414">
          New
        </span>
        <span className="text-3xl font-light text-blue-600" data-id="element-415">{counts.new}</span>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-sm" data-id="element-416">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1" data-id="element-417">
          Requested
        </span>
        <span className="text-3xl font-light text-amber-600" data-id="element-418">
          {counts.requested}
        </span>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-sm" data-id="element-419">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1" data-id="element-420">
          Review
        </span>
        <span className="text-3xl font-light text-purple-600" data-id="element-421">
          {counts.review}
        </span>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-sm" data-id="element-422">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1" data-id="element-423">
          Cleared
        </span>
        <span className="text-3xl font-light text-emerald-600" data-id="element-424">
          {counts.cleared}
        </span>
      </div>
    </div>;
}